import './styles.scss'

import { Trans, useTranslation } from 'react-i18next'

import B2BecLink from '@/components/B2BLink'
import CustomButton from '@/components/CustomButton'

import { B2BEC_OVERVIEWGUIDE_TYPES } from './overview-guide-block.constants'

const B2BEC_OVERVIEWGUIDE_URL = {
  [B2BEC_OVERVIEWGUIDE_TYPES.MY_MACHINES]: '/my-machines',
  [B2BEC_OVERVIEWGUIDE_TYPES.MY_ORDERS]: '/orders',
  [B2BEC_OVERVIEWGUIDE_TYPES.PRODUCTS]: '/categories',
}

const RenderLink = ({ link, isExternalLink, children }) => {
  if (isExternalLink) {
    return (
      <a href={link} target="noreferrer">
        {children}
      </a>
    )
  }

  return <B2BecLink to={link}>{children}</B2BecLink>
}

export const B2becGuideBlock = (props) => {
  const {
    type,
    Icon,
    link,
    isExternalLink = false,
    scope = 'adminWorkspace',
  } = props
  const { t } = useTranslation()

  return (
    <div className="b2bec-overview-guide">
      <h3 className="overview-guide__title">{t(`${scope}.${type}.title`)}</h3>
      <div className="b2bec-overview-guide__icon">{Icon}</div>
      <div className="b2bec-overview-guide__description">
        <Trans
          components={[<span key={link} />]}
          i18nKey={`${scope}.${type}.description`}
        />
      </div>
      <div className="b2bec-overview-guide__button">
        <RenderLink isExternalLink={isExternalLink} link={link}>
          <CustomButton buttonSize="small" title={t(`${scope}.${type}.button`)}>
            <Trans i18nKey={`${scope}.${type}.button`} />
          </CustomButton>
        </RenderLink>
      </div>
    </div>
  )
}

function getImageUrl(type) {
  // note that this does not include files in subdirectories
  return new URL(`../../assets/img/overviewGuide/${type}.webp`, import.meta.url)
    .href
}

const B2becOverviewGuideBlock = ({
  type = B2BEC_OVERVIEWGUIDE_TYPES.MY_MACHINES,
}) => (
  <B2becGuideBlock
    link={B2BEC_OVERVIEWGUIDE_URL[type]}
    scope="overviewGuide"
    type={type}
    Icon={<img alt={type} height={62} src={getImageUrl(type)} width={63} />}
  />
)

export default B2becOverviewGuideBlock
